import { useMemo } from 'react';

import { SUPPORTED_CLOUD_TO_PERMISSIONS_CENTER_CLOUD } from 'features-op/permissions-center/constants';
import { SupportedCloudProvider as PermissionsCenterSupportedCloudProvider } from 'features-op/permissions-center/types';
import { FeatureSelection } from 'hooks/dialogs/cluster/types';
import { usePermissionCenterFeaturesListQuery } from 'hooks/queries/permissions-center/usePermissionCenterFeaturesListQuery';
import { notReachable } from 'utils/types/not-reachable';

import { mapFeatureSelectionToPermissionsCenterFeatures } from './_utils';
import { PermissionsSummaryContent } from './PermissionsSummaryContent';

type Props = {
  cloudProvider: PermissionsCenterSupportedCloudProvider;
  selectedFeatures: FeatureSelection;
};

export const PermissionsSummary = ({
  cloudProvider,
  selectedFeatures,
}: Props) => {
  const query = usePermissionCenterFeaturesListQuery({
    params: {
      clouds: [SUPPORTED_CLOUD_TO_PERMISSIONS_CENTER_CLOUD[cloudProvider]],
    },
  });

  const selectedPermissionsCenterFeatures = useMemo(
    () => mapFeatureSelectionToPermissionsCenterFeatures(selectedFeatures),
    [selectedFeatures]
  );

  switch (query.status) {
    case 'pending':
      return (
        <PermissionsSummaryContent
          cloudProvider={cloudProvider}
          selectedPermissionsCenterFeatures={selectedPermissionsCenterFeatures}
          permissionsCenterFeatures={undefined}
          isLoading
        />
      );
    case 'success':
      return (
        <PermissionsSummaryContent
          cloudProvider={cloudProvider}
          permissionsCenterFeatures={query.data.items}
          selectedPermissionsCenterFeatures={selectedPermissionsCenterFeatures}
          isLoading={false}
        />
      );
    case 'error':
      return <PermissionsSummaryContent.Error refetch={query.refetch} />;
    default:
      return notReachable(query);
  }
};
